export default __webpack_public_path__ + "static/media/terraform.4ac044db.png";